import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw } from "lucide-react";

const CHUNK_RE = /(ChunkLoadError|Loading chunk|dynamically imported module|Importing a module script failed|Unexpected token '<')/i;

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // A stale cached bundle after a deploy throws a chunk/module error -> reload once to fetch fresh assets.
    const msg = (error && (error.message || String(error))) || "";
    if (CHUNK_RE.test(msg) && !sessionStorage.getItem("wh_chunk_reloaded")) {
      sessionStorage.setItem("wh_chunk_reloaded", "1");
      window.location.reload();
    }
  }

  componentDidUpdate(prevProps) {
    // Reset the boundary when the route changes so an error on one page doesn't stick.
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] grid place-items-center p-6" data-testid="error-boundary">
          <div className="text-center max-w-md">
            <div className="h-12 w-12 rounded-xl bg-amber-100 text-amber-600 grid place-items-center mx-auto mb-4">
              <AlertTriangle className="h-6 w-6" />
            </div>
            <h2 className="text-lg font-semibold">Bu sayfa yüklenirken bir sorun oluştu</h2>
            <p className="text-sm text-muted-foreground mt-1.5">Sayfayı yenileyerek tekrar deneyebilirsiniz. Sorun sürerse yöneticinize bildirin.</p>
            <Button className="mt-4" onClick={() => window.location.reload()} data-testid="error-reload-button">
              <RefreshCw className="h-4 w-4 mr-1.5" /> Sayfayı Yenile
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
